import { createContext, useContext, type ReactNode } from 'react';
import type { DocumentoDoSite, Lingua } from './documento-do-site';

/**
 * O site do construtor que a vitrine está desenhando.
 *
 * `editor` liga o modo de edição (a loja aberta dentro do painel): os blocos
 * não navegam nem compram, só se deixam selecionar.
 */
export interface Site {
  doc: DocumentoDoSite;
  lingua: Lingua;
  editor: boolean;
  /** Só no editor: a página que o painel pediu (a rota pode ter ido para outro lugar). */
  pagina?: string;
  /** Só no editor: a rota que mostra essa página (com um produto ou notícia de amostra). */
  rota?: string;
  /** Só no editor: o conteúdo de fluxo vira um marcador (página que pede login, ou sem amostra). */
  marcador?: boolean;
  /** Só no editor: o bloco selecionado no painel. */
  selecionado?: string | null;
  /** Só no editor: o modo que o painel quer ver. */
  modo?: 'claro' | 'escuro';
}

const SiteContext = createContext<Site | null>(null);

export function SiteProvider({ site, children }: { site: Site; children: ReactNode }) {
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export function useSite(): Site {
  const s = useContext(SiteContext);
  if (!s) throw new Error('useSite fora do SiteProvider');
  return s;
}

/** A língua da vitrine (i18next) reduzida às três do construtor. */
export function linguaDoSite(idioma: string | undefined): Lingua {
  const base = (idioma || 'pt').split('-')[0];
  return base === 'en' || base === 'es' ? base : 'pt';
}
